import { Component, OnInit, ViewEncapsulation, Output, EventEmitter, OnDestroy } from '@angular/core';
import { Location } from "@angular/common";
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-user-management',
  templateUrl: './user-management.component.html',
  styleUrls: ['./user-management.component.scss'],
})
export class UserManagementComponent implements OnDestroy {
  public activateButtons: boolean = true;

  /**
   *
   * If we want to hide the buttons we can add [hidden]="!showButtons" to each button when the path is not /user-management
   * and uncomment the below code
   */
  constructor(private authService: AuthService) { }

  ngOnInit() {
    this.activateButtons = this.authService.isLoggedInAndAdmin || this.authService.isLoggedInCustomerAdmin;
  }

  ngOnDestroy() { }

}
